export const ENDPOINTS = {
  // AUTH
  authenticate: () => `/api/User/Authenticate`,
  checkEmail:() => '/api/NewCastingNotice/check-email',
  checkUserName: () => '/api/NewCastingNotice/check-userName',

  // NOTIFICATIONS
  getActiveNotifications: () => `/api/User/GetActiveNotifications`,
  dismissNotification: () => `/api/Admin/DismissNotification`,
  getNotifications: ({ userId, userRole }) =>
    `/api/User/GetActiveNotifications?userId=${userId}&userRole=${userRole}`,
  getNotificationMessages: ({ notificationId = 0 }) =>
    `/api/Admin/GetNotificationMessages?notificationId=${notificationId}`,

  // CASTING NOTICES
  getCastingNotices: ({ email, page, pageSize, noticeId = 0 }) =>
    `/api/NewCastingNotice/GetNewCastingNoticeDetails?noticeId=${noticeId}&page=${page}&pageSize=${pageSize}&email=${encodeURIComponent(email)}`,
  getNoticeDetails: ({ email, noticeId, page = 1, pageSize = 50 }) =>
    `/api/NewCastingNotice/GetNewCastingNoticeDetails?noticeId=${noticeId}&email=${encodeURIComponent(email)}&page=${page}&pageSize=${pageSize}`,

  addOrUpdateNotice: () => `/api/NewCastingNotice/AddNoticeDetails`,
  getRoleDetails: ({ noticeId, page, pageSize }) =>
    `/api/NewCastingNotice/GetRoleDetails?noticeId=${noticeId}&page=${page}&pageSize=${pageSize}`,
  addOrUpdateRole: () => `/api/NewCastingNotice/AddRoleDetails`,
  deleteRole: ({ roleId }) =>
    `/api/NewCastingNotice/DeleteRoleDetails?roleId=${roleId}`,
  getProjectSubmissions: ({ noticeId }) =>
    `/api/NewCastingNotice/GetProjectSubmissions?noticeId=${noticeId}`,
  getTalentDetails: ({ userIds, roleId, clientId, sortBy }) =>
  `/api/NewCastingNotice/GetTalentDetails?userIds=${userIds}&roleId=${roleId}&clientId=${clientId}&sortBy=${sortBy}`,
  updateUserList: () => `/api/NewCastingNotice/UpdateUserList`,

  // USER DATA / LOOKUPS
  getUnions: () => `/api/User/allAffiliations`,
  getJobCategories: () => `/api/User/get-all-job-categories`,
  getEyeColors: () => `/api/User/get-eye-colors`,
  getHairColors: () => `/api/User/get-hair-colors`,
  getLocations: () => `/api/User/GetLocations`,
  getVocalRanges: () => `/api/User/get-vocal-ranges`,
  getVocalTypes: () => `/api/User/GetVocalTypes`,
  getEthnicities: () => `/api/User/get-all-ethnicities`,
  getPayTypes: () => `/api/User/get-all-paytypes`,

  // ADMIN
  getAllRoles: () => `/api/Admin/GetAllRoles`,
  getUsersByRole: () => `/api/Admin/GetUserDetailsBasedOnRole`,
  getAdminFilteredNotices: () => `/api/Admin/GetApprovedorunApprovedNotices`,
  ApproveOrRejectNotice: () => `/api/Admin/ApproveOrRejectNotice`,
  sendNoticeApproveEmail: "/api/Admin/SendNoticeApproveEmail",
  deleteUser: () => `/api/Admin/DeleteUser`,
  getNoticeStatusCounts: () => `/api/Admin/GetNoticeStatusCounts`,
  getCountryCodes: () => `/api/User/GetCountryCodes`,

  getQuestions: () => `/api/Admin/GetQuestions`,
  addOrUpdateQuestion: () => `/api/Admin/AddOrUpdateQuestion`,
  deleteQuestion: ({ questionId, userId }) =>
    `/api/Admin/DeleteQuestion?questionId=${questionId}&userId=${userId}`,
getEthnicityOptions: () => "/api/User/get-all-ethnicities",

// EVENT MAILER
  getAudienceTypes: () => `/api/Admin/GetAudienceTypes`,
  getAudienceCount: ({ audienceTypeId }) =>
    `/api/Admin/GetAudienceCount/${encodeURIComponent(audienceTypeId)}`,

  addEvent: () => `/api/Admin/AddEvent`,
  getEvents: () => `/api/Admin/GetEvents`,
  updateEvent: () => `/api/Admin/UpdateEvent`,
  deleteEvent: ({ eventId }) =>
    `/api/Admin/DeleteEvent/${encodeURIComponent(eventId)}`,

  addEventMessage: () => `/api/Admin/AddEventMessage`,
  getEventMessages: ({ eventId, audienceTypeId }) =>
    `/api/Admin/GetEventMessages?eventId=${encodeURIComponent(
      eventId,
    )}&audienceTypeId=${encodeURIComponent(audienceTypeId)}`,
  updateEventMessage: () => `/api/Admin/UpdateEventMessage`,
  deleteEventMessage: ({ eventMessageId }) =>
    `/api/Admin/DeleteEventMessage/${encodeURIComponent(eventMessageId)}`,

  sendEventMail: () => `/api/Admin/SendEventMail`,
  sendTestEventMail: () => "/api/Admin/SendTestEventMail",
  getEmailContent: (id) => `/api/Admin/GetEmailContent?id=${id}`,

    isClientFavoriteTalent: ({ clientId, talentId }) =>
    `/api/NewCastingNotice/IsClientFavoriteTalent?clientId=${encodeURIComponent(
      clientId,
    )}&talentId=${encodeURIComponent(talentId)}`,


  // ACCOUNT
  getAccountPage: ({ email }) =>
    `/api/NewCastingNotice/GetClientDetails?email=${encodeURIComponent(email)}`,
  updateClientDetails: () => `/api/NewCastingNotice/updateClientDetails`,
  changePassword: () => `/api/User/ChangePassword`,
  forgotPassword: () => `/api/User/ForgotPassword`,
  forgotUsername: () => `/api/User/ForgotUsername`,

  getUserActiveStatus: ({ userId }) =>
  `/api/NewCastingNotice/user-active-status?userId=${encodeURIComponent(userId)}`,

  // SEARCH & HISTORY
  getFilteredNotices: () => `/api/SearchNotice/GetFilteredNotices`,
  getExpiredFilteredNotices: () =>
    `/api/SearchNotice/GetExpiredFilteredNotices`,
  searchTalentProfiles: () => `/api/SearchProfiles/SearchTalentProfiles`,
  submitJob: () => `/api/SearchNotice/SubmitaJob`,
  getUserJobHistory: ({ userId }) =>
    `/api/SearchNotice/GetUserJobHistory/${userId}`,

  // TALENT PROFILE (CRUD)
  updateTalentProfile: () => `/api/TalentProfile/update-talent-profile`,
  addOrUpdateResumeText: () => `/api/TalentProfile/AddOrUpdateResumeText`,
  addOrUpdateRepresentation: () =>
    `/api/TalentProfile/AddOrUpdateRepresentationInformation`,
  addOrUpdateVocalTypes: () => `/api/TalentProfile/AddorUpdateUserVocalTypes`,
  addOrUpdateAffiliations: () => `/api/TalentProfile/AddorUpdateAffiliations`,

  // Resume Management (clean + standardized)
  addOrUpdateResumeSection: () => `/api/TalentProfile/AddOrUpdateResumeSection`,
  addOrUpdateResumeSectionDetails: () =>
    `/api/TalentProfile/AddOrUpdateResumeSectionDetails`,

  addOrUpdateUserMedia: () => `/api/TalentProfile/AddOrUpdateUserMedia`,

  // Deprecated / internal (kept for backward compatibility)
  saveResumeSection: () => `/api/TalentProfile/addorupdateresumesection`,
  getUnreadMessageCount: () => "/api/NewCastingNotice/GetUnreadMessageCount",

  //save search
  saveCastingSearch: () => "/api/SearchNotice/SaveCastingSearch",
  getCastingSearch: () => "/api/SearchNotice/GetCastingSearch",

  // TALENT PROFILE (GET)
  getResumeSections: ({ userId }) =>
    `/api/TalentProfile/GetResumeSectionsWithDetails/${encodeURIComponent(
      userId,
    )}`,
  getResumeTextData: ({ userId }) =>
    `/api/TalentProfile/GetUserResumeTextData/${encodeURIComponent(userId)}`,
  getAllRepresentationHeadings: () =>
    `/api/User/get-all-representation-headings`,

  // Get representation info by user + heading
  // Swagger: GET /api/TalentProfile/GetRepresentationInformation/{userId}/{headingName}
  getRepresentationInformation: (userId, headingName) =>
    `/api/TalentProfile/GetRepresentationInformation/${encodeURIComponent(
      userId,
    )}/${encodeURIComponent(headingName)}`,

  // Add or update representation
  // Swagger: POST /api/TalentProfile/AddOrUpdateRepresentationInformation
  addOrUpdateRepresentation: () =>
    `/api/TalentProfile/AddOrUpdateRepresentationInformation`,

  getUserAffiliations: ({ userId }) =>
    `/api/TalentProfile/GetUserAffiliations/${encodeURIComponent(userId)}`,
  getUserMedia: ({ userId }) =>
    `/api/TalentProfile/GetUserMedia/${encodeURIComponent(userId)}`,

  // FAVORITES
  getFavoriteTalentDetails: ({ clientId, page, pageSize }) =>
    `/api/NewCastingNotice/GetClientFavoriteTalentDetails?clientId=${encodeURIComponent(
      clientId,
    )}&page=${page}&pageSize=${pageSize}`,
  addOrUpdateFave: () => `/api/NewCastingNotice/AddOrUpdateFave`,
getTalentNotes: (talentId, directorId) =>
  `/api/NewCastingNotice/GetTalentNotes?talentId=${talentId}&directorId=${directorId}`,
  addOrUpdateTalentNote: () => `/api/NewCastingNotice/AddOrUpdateTalentNote`,

  // MESSAGES
  getUserResumeMessagesWithCounts: () =>
    `/api/SearchNotice/GetUserResumeMessagesWithCounts`,
getUserTalentMessages: ({
  type,
  email,
  page = 1,
  limit = 10,
  sortOrder = "Latest",
}) => {
  return `/api/NewCastingNotice/Get${
    type.charAt(0).toUpperCase() + type.slice(1)
  }TalentMessages?email=${encodeURIComponent(
    email
  )}&page=${page}&pageSize=${limit}&sortOrder=${encodeURIComponent(
    sortOrder
  )}`;
},
getUserMessages: ({ type, email, page, limit, sortOrder = "Latest" }) => {
  const baseUrl = `/api/NewCastingNotice/Get${
    type.charAt(0).toUpperCase() + type.slice(1)
  }Messages`;

  let queryString =
    `email=${encodeURIComponent(email)}` +
    `&page=${page}` +
    `&pageSize=${limit}` +
    `&sortOrder=${encodeURIComponent(sortOrder)}`;

  if (type === "archive") {
    queryString += "&user=director";
  }

  return `${baseUrl}?${queryString}`;
},
getArchiveTalentMessages: ({ email, page, limit, sortOrder = "Latest" }) =>
  `/api/NewCastingNotice/GetArchiveTalentMessages?email=${encodeURIComponent(email)}&user=Talent&page=${page}&pageSize=${limit}&sortOrder=${encodeURIComponent(sortOrder)}`,

getArchiveMessages: ({ email, page, limit, sortOrder = "Latest" }) =>
  `/api/NewCastingNotice/GetArchiveMessages?email=${encodeURIComponent(email)}&user=Director&page=${page}&pageSize=${limit}&sortOrder=${encodeURIComponent(sortOrder)}`,
  showInboxMessages: () => `/api/NewCastingNotice/ShowInboxMessages`,
  sendMessage: () => `/api/NewCastingNotice/SendMessage`,
  addOrUpdateNotificationMessage: () =>
    `/api/Admin/AddOrUpdateNotificationMessage`,
  archiveMessages: () => `/api/NewCastingNotice/archive`,
  deleteMessages: () => `/api/NewCastingNotice/delete`,
  moveToInbox: () => `/api/NewCastingNotice/MoveToInbox`,

  // USER MGMT
  addNewUserDetails: () => `/api/User/AddNewUserDetails`,
  // PAYMENT
  processPayment: () => `/api/Admin/payment`,
  createCheckout: () => `/api/Admin/create-checkout`,
  saveTalentFavoriteNotice: () => "/api/TalentProfile/SaveTalentFavoriteNotice",

  getPlans: () => "/api/Admin/GetPlans",
  // USER NOTIFICATION PREFS
  getUserNotificationPrefs: ({ userId }) =>
    `/api/SearchNotice/GetUserNotificationPrefs?userId=${userId}`,
  addOrUpdateUserNotificationPrefs: () =>
    `/api/SearchNotice/add-or-updateUserNotificationPrefs`,

  // USER PROFILE (fixed)
  getUserId: ({ userName }) =>
    `/api/User/GetUserId?userName=${encodeURIComponent(userName)}`,
  getUserName: ({ userId }) =>
    `/api/User/GetUserName?userId=${encodeURIComponent(userId)}`,
  getTalentProfile: ({ userId }) =>
    `/api/TalentProfile/get-talent-profile/${encodeURIComponent(userId)}`,
  updateResumeName: ({ userId, name }) =>
    `/api/User/UpdateResumeName?userId=${encodeURIComponent(
      userId,
    )}&name=${encodeURIComponent(name)}`,
getBulkEmailBatches: ({ fromDate, toDate, page = 1, pageSize = 100 }) => {
  const params = new URLSearchParams({
    fromDate,
    toDate,
    page: String(page),
    pageSize: String(pageSize),
  });

  return `/api/Admin/GetBulkEmailBatches?${params.toString()}`;
},

  /*     getTalentProfile: ({ userId }) =>
    `/api/TalentProfile/GetUserTalents/${userId}`, */

  updateTalentProfile: () => `/api/TalentProfile/update-talent-profile`,

  getTalentProfileDetails: ({ userId }) =>
    `/api/TalentProfile/get-talent-profile/${userId}`,

  getActiveTalents: () => `/api/User/active-talents`,

  addOrUpdateTalentTypes: () => `/api/TalentProfile/AddorUpdateTypeofTalent`,
  getUserTalents: ({ userId }) => `/api/TalentProfile/GetUserTalents/${userId}`,
  GET_USER_PRIVACY_SETTINGS: "/api/User/GetUserPrivacySettings",
  SAVE_USER_PRIVACY_SETTINGS: "/api/User/SaveUserPrivacySettings",
  NotifyUserOnNoticeSubmission: ({ userName, email }) =>
    `/api/NewCastingNotice/NotifyUserOnNoticeSubmission?userName=${userName}&email=${email}`,
isVerifiedDirector: () =>
  `/api/User/IsVerifiedDirector`,

  // NAVIGATION (used in onboarding)
  getUserNavigation: ({ userId }) =>
    `/api/User/GetUserNavigation/${encodeURIComponent(userId)}`,
  // CONTACT
  contactUs: ({ name, email, department, message }) =>
    `/api/User/ContactUsDetails?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}&department=${encodeURIComponent(department)}&message=${encodeURIComponent(message)}`,
};
